import type { HelpFile } from '../../types/help'
import { OutboundConnectorsTestIds } from '../../../testids/OutboundConnectorsTestIds'

export const outboundConnectorsHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [OutboundConnectorsTestIds.outboundConnectorsList]: 'Connectors that link target systems to the IAM platform for automated account provisioning and synchronization.',
    [OutboundConnectorsTestIds.colSystem]: 'Target system this connector is linked to.',
    [OutboundConnectorsTestIds.colType]: 'Connector protocol — SCIM, REST, LDAP, or Database.',
    [OutboundConnectorsTestIds.colStatus]: 'Enabled or Disabled — disabled connectors do not process provisioning tasks.',
    [OutboundConnectorsTestIds.colLastUpdated]: null,
    [OutboundConnectorsTestIds.connectorsTable]: null,
    [OutboundConnectorsTestIds.connectorsSkeleton]: null,
    [OutboundConnectorsTestIds.connectorTypeSelect]: 'Filter by connector protocol type.',
    [OutboundConnectorsTestIds.createConnectorButton]: null,
  },
}
